import * as z from "zod";

export const getTotalOrdersOverTime = {
  name: "getTotalOrdersOverTime" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    data: z.array(z.object({ date: z.string(), value: z.number() })),
  }),
};
